import { Box, Container, Slide, Typography } from "@mui/material";
import useScreenClass from "hooks/useScreenClass";
import { useRef } from "react";
import timasColor from "./timasColor";
import { hsse } from "./timasImages";

function TimasHero(props) {
  const rootRef = useRef(null);
  const sc = useScreenClass();
  const { backgroundUrl, title, description, children, backgroundSx } = props;

  return (
    <Box
      sx={{
        position: "relative",
        pt: sc.upToMd ? 16 : 30,
        pb: 16,
        px: sc.upToLg && sc.downToMd && 8
      }}
      ref={rootRef}
    >
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          background: `${timasColor.blackGradient}, url(${backgroundUrl ||
            hsse})`,
          backgroundBlendMode: "multiply",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          ...backgroundSx
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
          pointerEvents: "none",
          backgroundColor: "rgba(37, 37, 37, 0.45)"
        }}
      />
      <Container sx={{ position: "relative", zIndex: 2 }}>
        {children || (
          <>
            {title && (
              <Slide in={true} direction="down">
                <Typography
                  component="h1"
                  variant="h6"
                  color={timasColor.white1}
                  sx={{ paddingBottom: "16px" }}
                >
                  {title}
                </Typography>
              </Slide>
            )}
            {description && (
              <Slide
                in={true}
                direction="up"
                container={rootRef.current}
                timeout={400}
              >
                <Typography
                  component="h2"
                  variant={sc.upToMd ? "h5" : "h4"}
                  color={timasColor.white}
                >
                  {description}
                </Typography>
              </Slide>
            )}
          </>
        )}
      </Container>
    </Box>
  );
}

export default TimasHero;
